import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

const Keys = {
  ZERO: 48,
  SEMICOLON: 59,
  NUMPAD_0: 96,
  NUMPAD_9: 105
}

/**
 * Only Number directive.
 * @description Angular directive. Applied to input, accept only number from user input.
 */
@Directive({
  selector: '[apOnlyNumber]'
})
export class OnlyNumberDirective {
  private static readonly NUM_CODE1 = Keys.ZERO;
  private static readonly NUM_CODE0 = Keys.SEMICOLON; // Should it be 59, not 57?
  private static readonly NUM_CODEPAD1 = Keys.NUMPAD_0;
  private static readonly NUM_CODEPAD0 = Keys.NUMPAD_9;

  @Output() onKeyDownEvent = new EventEmitter<void>();

  public el: ElementRef;

  private readonly specialKeys: Array<string> = ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Left', 'Right', 'Del'];

  constructor(el: ElementRef) {
    this.el = el;
  }

  /**
   * Bind to keydown event, accept or not the character inserted by user
   * @param event keydown event
   */
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    this.onKeyDownEvent.next();

    if (!event.target) {
      return;
    }
    // TODO: Rework this logics in order to replace deprecated keyCode with event.key
    if (this.specialKeys.includes(event.key) || this.isNumeric(Number(event.keyCode))) {
      return;
    }

    event.preventDefault();
  }

  private isNumeric(value: number) {
    const isNumericKeyboard = value >= OnlyNumberDirective.NUM_CODE1 && value <= OnlyNumberDirective.NUM_CODE0;
    const isNumericNumpad = value >= OnlyNumberDirective.NUM_CODEPAD1 && value <= OnlyNumberDirective.NUM_CODEPAD0;
    return isNumericKeyboard || isNumericNumpad;
  }
}
